import { useChatbotMessages } from './useChatbotMessages';
import { useChatbotPreview } from './useChatbotPreview';
import { useLeadForm } from './useLeadForm';
import { useResponsiveLayout } from './useResponsiveLayout';

function useChatbotWidget() {
  const {
    chatbotData,
    messages,
    isSending,
    updateMessages,
    handleReaction,
    contentRef,
    reactions,
    faqQuestionId,
    setFaqQuestionId,
    isFetching,
  } = useChatbotMessages();

  const {
    uploadedFiles,
    setUploadedFiles,
    isFieldSubmit,
    setIsFieldSubmit,
    leadFormik,
    isUploadFileLoading,
    handleFileChange,
    handleTelInputChange,
    handleLeadFormClose,
    handleSelectChange,
    renderLeadForm,
    isProcessingFiles,
    handleRemoveFile,
    fileRef,
    isLeadSubmitLoading,
  } = useLeadForm(chatbotData, faqQuestionId, setFaqQuestionId);

  const { handlePreviewToggle, inputField, handleChange, submitForm, handleEnterKeyPress } = useChatbotPreview(
    updateMessages,
    setFaqQuestionId,
    contentRef,
    isFieldSubmit,
    setIsFieldSubmit,
    setUploadedFiles
  );

  const { isResponsive } = useResponsiveLayout(faqQuestionId);

  return {
    chatbotData,
    handlePreviewToggle,
    messages,
    isSending,
    faqQuestionId,
    uploadedFiles,
    isFieldSubmit,
    contentRef,
    inputField,
    leadFormik,
    isUploadFileLoading,
    reactions,
    renderLeadForm,
    updateMessages,
    handleChange,
    handleEnterKeyPress,
    submitForm,
    handleReaction,
    handleFileChange,
    handleTelInputChange,
    handleLeadFormClose,
    isResponsive,
    handleSelectChange,
    isProcessingFiles,
    handleRemoveFile,
    fileRef,
    isLeadSubmitLoading,
    isFetching,
  };
}

export default useChatbotWidget;
